module.exports = "/_next/static/images/fallback_M-64adfe157e50cf7ae3a3b20d427bce6b.png";